import React, { useState } from "react";
import styles from "./link.module.scss";
import { Link as NavLink, useLocation } from "react-router-dom";
import { Tooltip } from "antd";
import IconOutline from "src/assets/icons/new-outline-info.svg?react";
import { LordIcon } from "../../lord-icon/lord-icon";
import { IconInfo } from "@constants";

type Props = {
  to?: string;
  iconUrl?: string;
  navIcon?: React.ReactNode;
  href?: string;
  target?: string;
  title?: string;
  isSubMenu?: boolean;
  onClick?: (e?: any) => void;
  className?: string;
  comingSoon?: boolean;
};

function MenuLink({
  to,
  iconUrl,
  navIcon,
  href,
  target,
  title,
  isSubMenu = true,
  onClick,
  className,
  comingSoon = false,
}: Props) {
  const { pathname } = useLocation();
  const [isHover, setIsHover] = useState(false);
  const active = pathname === to;

  return (
    <div className={styles.menuWrapper}>
      {!!href ? (
        <a
          onClick={onClick}
          className={`${styles.container} ${active ? styles.active : ""} ${className || ""
            }`}
          href={href}
          target={target}
        >
          {iconUrl &&
            <div className={styles.menuLeftIcon}>
              <LordIcon
                src={iconUrl}
                isHover={isHover}
                target=".ant-menu-submenu-title"
              />
            </div>
          }
          {navIcon && <div className={styles.menuRightIcon}>{navIcon}</div>}
        </a>
      ) : !!to ? (
        <NavLink
          onClick={onClick}
          className={`${styles.container} ${active ? styles.active : ""} ${className || ""
            }`}
          to={to || ""}
        >
          {iconUrl &&
            <div className={styles.menuLeftIcon}>
              <LordIcon
                src={iconUrl}
                isHover={isHover}
                target=".ant-menu-submenu-title"
              />
            </div>
          }
          {navIcon && <div className={styles.menuRightIcon}>{navIcon}</div>}
        </NavLink>
      ) : (
        <div
          onClick={onClick}
          className={`${styles.container} ${active ? styles.active : ""} ${className || ""
            }`}
          onMouseOver={() => {setIsHover(true)}}
          onMouseLeave={() => {setIsHover(false)}}
          style={{ cursor: comingSoon ? "default" : "pointer" }}
        >
          <div className={styles.menuItemContent}>
            {iconUrl &&
              <div className={styles.menuLeftIcon}>
                <LordIcon
                  src={iconUrl}
                  isHover={isHover}
                  target={isSubMenu ? ".ant-menu-submenu-title" : ".ant-menu-item"}
                />
              </div>
            }
            <div className={styles.menuItemSubTitle}>
              {title}
            </div>
          </div>

          {navIcon && <div className={styles.menuRightIcon}>{navIcon}</div>}
        </div>
      )}
    </div>
  );
}

export default MenuLink;
